export const APP_LOCALES = ['pt', 'en'] as const;
export type AppLocale = (typeof APP_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'pt';

export const CONTENTFUL_LOCALE_MAP: Record<AppLocale, string> = {
  pt: 'pt',
  en: 'en',
};

export function isAppLocale(value: string): value is AppLocale {
  return (APP_LOCALES as readonly string[]).includes(value);
}

export function toContentfulLocale(locale: AppLocale): string {
  return CONTENTFUL_LOCALE_MAP[locale];
}
